import React from 'react';
import {
  CONSENTIMIENTO_TITULO,
  CONSENTIMIENTO_INTRO,
  CONSENTIMIENTO_APARTADOS,
  CONSENTIMIENTO_OBLIGATORIO,
  CONSENTIMIENTO_OPCIONAL,
} from '../../config/consentimientoCuestionarios';

/**
 * Bloque de INFORMACIÓN SOBRE PROTECCIÓN DE DATOS + las dos casillas,
 * idéntico en tablet, en consulta y en la plataforma del paciente.
 * El texto NO se escribe aquí: vive en config/consentimientoCuestionarios.js.
 *
 * Props:
 *   aceptado / onAceptar        → casilla OBLIGATORIA (sin ella no se continúa)
 *   investigacion / onInvestigacion → casilla OPCIONAL (no bloquea)
 *   grande                      → tipografía mayor para la tablet
 */
const ConsentimientoDatos = ({
  aceptado,
  onAceptar,
  investigacion,
  onInvestigacion,
  grande = false,
}) => {
  const txt = grande ? 'text-base' : 'text-sm';
  return (
    <div className="space-y-4">
      <div className={`${txt} text-gray-700 max-h-72 overflow-y-auto rounded-xl border border-gray-200 bg-gray-50 p-4 space-y-2`}>
        <h3 className="font-semibold text-gray-900">{CONSENTIMIENTO_TITULO}</h3>
        <p>{CONSENTIMIENTO_INTRO}</p>
        {CONSENTIMIENTO_APARTADOS.map((ap) => (
          <p key={ap.titulo}>
            <strong>{ap.titulo}:</strong> {ap.texto}
          </p>
        ))}
      </div>

      {/* Casilla OBLIGATORIA */}
      <label
        className={`flex items-start gap-3 p-4 rounded-xl border-2 cursor-pointer transition-all ${
          aceptado ? 'border-teal-500 bg-teal-50' : 'border-gray-200 hover:border-gray-300'
        }`}
      >
        <input
          type="checkbox"
          checked={!!aceptado}
          onChange={(e) => onAceptar(e.target.checked)}
          className="mt-0.5 w-5 h-5 accent-teal-600 flex-none"
        />
        <span className={`${txt} text-gray-800`}>
          {CONSENTIMIENTO_OBLIGATORIO}{' '}
          <span className="text-gray-500">(obligatoria para continuar)</span>
        </span>
      </label>

      {/* Casilla OPCIONAL · nunca bloquea */}
      <label
        className={`flex items-start gap-3 p-4 rounded-xl border-2 cursor-pointer transition-all ${
          investigacion ? 'border-teal-300 bg-teal-50/50' : 'border-gray-200 hover:border-gray-300'
        }`}
      >
        <input
          type="checkbox"
          checked={!!investigacion}
          onChange={(e) => onInvestigacion(e.target.checked)}
          className="mt-0.5 w-5 h-5 accent-teal-600 flex-none"
        />
        <span className={`${txt} text-gray-700`}>
          <span className="text-gray-500">Opcional: </span>
          {CONSENTIMIENTO_OPCIONAL}
        </span>
      </label>
    </div>
  );
};

export default ConsentimientoDatos;
